import { AppStorage } from "./AppStorage.js";
const customerAuthTokenName = "customer";
const queryAuthParam = () => {
  const { location } = window;
  return new URLSearchParams(location.search);
};
const authHeader = () => {
  const customer = AppStorage.get(customerAuthTokenName);
  const jwtToken = queryAuthParam().get("jwtToken");
  if (jwtToken || (customer == null ? void 0 : customer.token)) {
    const token = jwtToken || (customer == null ? void 0 : customer.token);
    return { Authorization: `Bearer ${token}` };
  }
  return null;
};
export {
  authHeader,
  authHeader as default,
  queryAuthParam
};
